import React, { FunctionComponent } from "react";

import { useLanguage } from "../../../i18n/useLanguage";
import { PackagePartItem } from "../../../queries/useSearchPartPackagesByVehicle";
import { Section } from "../../../ui/Section/Section";
import { SectionHeading } from "../Common/SectionHeading";

type PackageWarningProps = {
  part: PackagePartItem | null;
};

export const PackageWarning: FunctionComponent<PackageWarningProps> = ({
  part,
}) => {
  const [language] = useLanguage();
  const warning = part?.partDetails.primaryPart.itemWarning[language];
  if (!warning) {
    return null;
  }
  return (
    <Section>
      <SectionHeading translation="searchResults.warning" />
      <p className="text-xs">{warning}</p>
    </Section>
  );
};
